<template>
  <b-modal
    id="return-modal"
    :title="$t('return')"
    cancel-variant="outline-secondary"
    :ok-title="$t('add')"
    :ok-variant="'success'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @hidden="resetModal"
    @ok="onSubmitCategory"
  >
    <b-form>
      <validation-observer ref="ptoValidations">
        <b-form-group :label="$t('amount')" for="amount">
          <validation-provider
            #default="{ errors }"
            :name="$t('amount')"
            rules="required"
          >
            <b-form-input
              type="number"
              v-model="ptoData.count"
              id="count"
              @keyup="getVal"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BFormSpinbutton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import { required } from "@validations";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    BFormFile,
    BFormDatepicker,
    BFormTextarea,
    BFormSpinbutton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    item: {
      type: Object,
      default: {},
    },
    type: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      required,
      arr: [],
      ptoData: {
        count: null,
      },
    };
  },
  methods: {
    ...mapActions("application", [
      "POST_FOR_GOOD_RETURN",
      "POST_FOR_INSTRUMENTS_RETURN",
    ]),
    ...mapActions("pto", ["CREATE_PTO_FOR_GOOD"]),
    getVal(val) {
      if (this.item.total_count < this.ptoData.count) {
        this.arr = [...this.ptoData.count.toString()];

        let index = this.arr.length - 1;

        this.arr.splice(index, 1);

        let number = parseFloat(this.arr.join(""));

        this.ptoData.count = number;
      }
    },
    resetModal() {
      this.ptoData = {
        count: null,
        for_what: null,
        where: null,
      };
    },
    onSubmitCategory(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.ptoValidations.validate().then((success) => {
        if (!success) {
          return;
        }

        if (this.type) {
          try {
            this.POST_FOR_INSTRUMENTS_RETURN({
              instrument: this.item.id,
              quantity: this.ptoData.count,
            }).then((res) => {
              this.$_okToast();
              this.$emit("reload");
              this.$nextTick(() => {
                this.$bvModal.hide("return-modal");
              });
            });
          } catch (err) {
            this.$_errToast(err);
          }
        } else {
          try {
            this.POST_FOR_GOOD_RETURN({
              good: this.item.id,
              quantity: this.ptoData.count,
            }).then((res) => {
              this.$_okToast();
              this.$emit("reload");
              this.$nextTick(() => {
                this.$bvModal.hide("return-modal");
              });
            });
          } catch (err) {
            this.$_errToast(err);
          }
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============
  },
};
</script>

<style scoped>
</style>
